import { render, staticRenderFns } from "./DocumentCompliance.vue?vue&type=template&id=6d6764b2&"
import script from "./DocumentCompliance.vue?vue&type=script&lang=js&"
export * from "./DocumentCompliance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports